import { FieldErrors } from 'react-hook-form';

export const phoneAutoHyphen = (phoneNumber: any) => {
  return phoneNumber && phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
};

export const formatPhoneNumber = (value: string): string => {
  const onlyNumbers = value.replace(/\D/g, '').slice(0, 11); // 숫자만, 11자리 제한

  if (onlyNumbers.length < 4) return onlyNumbers;
  if (onlyNumbers.length < 8) return `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3)}`;
  return `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3, 7)}-${onlyNumbers.slice(7)}`;
};

export const validateEmail = (email: string) => {
  // 정규식을 사용하여 이메일 형식을 검사합니다.
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailRegex.test(email);
};

export const extractDate = (dateTimeString: string | undefined) => {
  return dateTimeString && dateTimeString.split('T')[0];
};

export const setError = (code: number) => {
  switch (code) {
    case 602:
      return '없는 계정입니다.';
    case 607:
      return '비밀번호가 틀렸습니다.';
    case 618:
      return '서비스를 이용할 수 없습니다.';
    default:
      return '재시도 부탁드립니다.';
  }
};

export const getSubscriptionType = (subscribetype: number) => {
  switch (subscribetype) {
    case 1:
      return '월구독';
    case 2:
      return '연구독';
    case 3:
      return '월후불';
    case 4:
      return '연후불';
    case 5:
      return '무료';
    default:
      return '';
  }
};

export const getSubScribeStatus = (status: string) => {
  switch (status) {
    case 'SUBSCRIBE':
      return '구독중';
    case 'STOPSUBSCRIBE':
      return '결제실패';
    case 'UNSUBSCRIBE':
      return '구독정지';
    default:
      return '-';
  }
};

export const scrollToErrorField = (errors: FieldErrors<any>) => {
  const firstErrorField = Object.keys(errors)[0];

  const element =
    document.querySelector(`[name="${firstErrorField}"]`) ||
    document.querySelector(`[data-error-name="${firstErrorField}"]`);

  console.log('스크롤:', element);

  if (element) {
    (element as HTMLElement).scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    (element as HTMLElement).focus?.();
  }
};

export const allowOnlyNumbers = (value: string): string => {
  return value.replace(/[^0-9]/g, '');
};
